import styled from 'styled-components';

import { Color } from '../../constants/Colors';
import { MediaQuery, Shadow, Transition } from '../../constants/Styles';
import { Typography } from '../../constants/Typographies';

export const HeaderLink = styled.a`
  cursor: pointer;
  border: none;
  width: 250px;
  background: transparent;
  display: flex;
  padding: 10px 15px;
  border-radius: 10px;
  transition: ${Transition.ALL_EASE};

  & > :first-child {
    flex: none;
    margin-right: 10px;
  }

  &:hover {
    transform: translateY(-2px) scale(1.005) translateZ(0);
    box-shadow: ${Shadow.BLUE_ACTIVE};
  }

  ${MediaQuery.L_AND_DOWN} {
    width: 100%;

    & > :not(:last-child) {
      display: none;
    }
  }
`;

export const MainContainer = styled.div`
  display: flex;

  button {
    align-items: center;
  }

  svg {
    padding-left: 5px;
    transition: ${({ isOpen }) => isOpen && Transition.ALL_EASE};
    transform: ${({ isOpen }) => isOpen && `translate(25%) rotate(-180deg)`};
  }
`;

export const ContentWrapper = styled.div`
  padding: 0px 10px;

  svg {
    font-size: 12px;
  }
`;

export const LinkWrapper = styled.div`
  padding-top: 5px;
`;

export const LinkLabel = styled.p`
  ${Typography.S_BOLDER};
  color: ${Color.CLOUD_BURST};
`;

export const LinkDescription = styled.p`
  ${Typography.XS};
  color: ${Color.DOLPHIN};
  padding-top: 5px;

  ${MediaQuery.L_AND_DOWN} {
    display: none;
  }
`;

export const OptionalButtonWrapper = styled.div`
  padding: 10px 15px;
`;
